import React from 'react'
import styles from "../../../CustomerDash/Components/schedulePOComps/Potable.module.css"

const VenPoTable = () => {
    const data = [
        { id: 1, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
        { id: 2, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
        { id: 3, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
        { id: 4, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
        { id: 5, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
        { id: 6, partNumber: 'LM239DR2G', quantity: 10, manufacturer: 'Molex' },
    ];
    return (
        <div className={styles.previewContainer}>
            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth} > Part #</th>
                        <th className={styles.previewth} >PO price</th>
                        <th className={styles.previewth}>Manufacture</th>
                        <th className={styles.previewth} >Total Qty</th>
                        <th className={styles.previewth} >Pending Quantity</th>
                        <th className={styles.previewth} >Schedule date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={item.id} className={styles.previewstripedRow}>
                            <td className={styles.previewtd} >
                                <div style={{ display: 'flex', gap: "6px" }}>
                                    <img src='/assets/Comparator.png' />
                                    <div>
                                        <a href=''>LM239DR2G</a> <br />Comparator Quad ±18V/36V 14-Pin SOICNT/R
                                    </div>
                                </div>
                            </td>
                            <td className={styles.previewtd} >100</td>
                            <td className={styles.previewtd} >
                                <div>
                                    <a href=''>Bocsh</a> <br /><span>Linear Comparators</span>
                                </div>
                            </td>
                            <td className={styles.previewtd} >40000</td>
                            <td className={styles.previewtd} >
                                <div>
                                    30000<br /><span>1000 in stock</span>
                                </div>
                            </td>
                            <td className={styles.previewtd}>
                                <div>
                                    12-10-24 <br /> <span>12-10-24 last disptach</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div style={{ display: "flex", justifyContent: "space-around", background: "#F1F1F3", fontSize: "12px", padding: "20px", margin: "0px 30px" }}>
                <div> Reschedule details</div>
                <div > Required qty :1000</div>
                <div>Reschedule date : 12-10-24</div>
                <div>On delivery</div>
            </div>
        </div>
    )
}

export default VenPoTable